import React from 'react'
import commercial from "../../images/commercial.png"
import landscape from "../../images/landscap.png"
import hospital from "../../images/hospital.png"
import interrior from "../../images/interrior.png"
import decor from "../../images/decor.png"
import { Link } from 'react-router-dom'

const Service = () => {
    return (
        <>
            <div className='container'>
                <h6 className='service-head '> ALL SERVICES</h6>
                <div className='row'>
                    <div className='col-lg-4 mb-5'>
                        <Link className="nav-link" to="/landscape">
                            <img src={landscape} height={200} className='w-100 br-20' alt={landscape} />
                        </Link>
                        <h3 className='color-primary text-center mt-2'>Landscape Design</h3>
                    </div>
                    <div className='col-lg-4 mb-5'>
                         <Link className="nav-link" to="/interior">
                            <img src={interrior} height={200} className='w-100 br-20' alt={interrior} />
                        </Link>
                        <h3 className='color-primary text-center mt-2'>Interior Design</h3>
                    </div>
                    <div className='col-lg-4 mb-5'>
                         <Link className="nav-link" to="/hospitality">
                            <img src={hospital} height={200} className='w-100 br-20' alt={hospital} />
                        </Link>
                        <h3 className='color-primary text-center mt-2'>Hospitality Design</h3>
                    </div>
                    <div className='col-lg-4 mb-5'>
                         <Link className="nav-link" to="/decor">
                            <img src={decor} height={200} className='w-100 br-20' alt={decor} />
                        </Link>
                        <h3 className='color-primary text-center mt-2'>Interior Decor</h3>
                    </div>
                    <div className='col-lg-4 mb-5'>
                         <Link className="nav-link" to="/commercial">
                            <img src={commercial} height={200} className='w-100 br-20' alt={commercial} />
                        </Link>
                        <h3 className='color-primary text-center mt-2'>Commercial Interior</h3>
                    </div>
                   
                </div>
            </div>
        </>
    )
}

export default Service
